import styled from "styled-components";

export const Container = styled.footer`
  background-color: #ffffff;
  border-top: 1px solid #e8e8e8;
  width: 100%;
  padding: 48px 40px;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 40px 24px;
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 1100px;
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 32px;
  }
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FooterLogo = styled.img`
  width: 160px;
  height: auto;
  object-fit: contain;
`;

export const SocialRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

export const SocialLink = styled.a`
  display: flex;
  align-items: center;
`;

export const SocialIcon = styled.img`
  height: 32px;
  width: 32px;
  object-fit: contain;
  opacity: 0.85;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;

export const Copyright = styled.p`
  font-family: 'Aileron', sans-serif;
  font-size: 13px;
  color: #888888;
  margin: 0;
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: row;
  gap: 80px;

  @media (max-width: 768px) {
    gap: 48px;
  }

  @media (max-width: 640px) {
    gap: 40px;
  }
`;

export const LinkColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const FooterLink = styled.span`
  font-family: 'Aileron', sans-serif;
  font-size: 15px;
  color: #000000;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.6;
  }
`;

export const FooterLinkBold = styled(FooterLink)`
  font-weight: 700;
`;
